// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export function nibbsOutgoingPaymentMapper(): $Shape<OutgoingPayment> {
  return {
    payment_type: 'ewallet',
    payment_type_code: 'nibbs',
  };
}
